import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { commonEnterpriseTrialSchema, newEnterprisePlanInvoiceSettingsSchema, newEnterprisePlanLimitsSchema, newMultiMonthlySubscriptionSchema, updateBillingCustomerSchema, } from './common-billing.dto';
export const startPartnerOrganizationEnterpriseSchema = z.object({
    limits: newEnterprisePlanLimitsSchema.optional(),
    subscription: newMultiMonthlySubscriptionSchema,
    invoice: newEnterprisePlanInvoiceSettingsSchema,
    customer: updateBillingCustomerSchema.optional(),
});
export class StartPartnerOrganizationEnterpriseDto extends createZodDto(startPartnerOrganizationEnterpriseSchema) {
}
export const startPartnerOrganizationEnterpriseTrialSchema = z.clone(commonEnterpriseTrialSchema);
export class PartnerOrganizationEnterpriseTrialDto extends createZodDto(startPartnerOrganizationEnterpriseTrialSchema) {
}
const partnerOrganizationSubscriptionResponseSchema = z.object({
    externalSubscriptionUrl: z.string().optional(),
});
export class PartnerOrganizationSubscriptionResponseDto extends createZodDto(partnerOrganizationSubscriptionResponseSchema) {
}
const partnerOrganizationTrialResponseSchema = partnerOrganizationSubscriptionResponseSchema.extend({
    // Deprecated: LucidSDK versions before LUCID-33886 require these, so WebService still sends them.
    // Remove once that LucidSDK version is deployed everywhere (after Nov 2nd 2026).
    // Clean up in LUCID-34911
    subscriptionId: z.number().optional(),
    parentPartnerOrganizationId: z.string().optional(),
    currentPartnerOrganizationId: z.string().optional(),
    currentBillingUnitId: z.uuid().optional(),
});
export class PartnerOrganizationTrialResponseDto extends createZodDto(partnerOrganizationTrialResponseSchema) {
}
const partnerOrganizationTrialSubscriptionConfigsResponseSchema = z.object({
    allowCustomStorage: z.boolean(),
    allowLegacyProviders: z.boolean(),
    allowOrgInvite: z.boolean(),
    allowServiceAccounts: z.boolean(),
    allowTeamCache: z.boolean(),
    allowNativeLayout: z.boolean(),
    expirationDate: dateParser().nullable(),
});
export class PartnerOrganizationTrialSubscriptionConfigsResponseDto extends createZodDto(partnerOrganizationTrialSubscriptionConfigsResponseSchema) {
}
export const updatePartnerOrganizationLimitsSchema = z.object({
    maxGuestLinks: z.number().positive(),
    maxEmailsPerGuestLink: z.number().positive(),
});
export class UpdatePartnerOrganizationLimitsDto extends createZodDto(updatePartnerOrganizationLimitsSchema) {
}
